module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "domain-select"
  }, [_vm._v(_vm._s(_vm.label)), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.domainId),
      expression: "domainId"
    }],
    attrs: {
      "options": _vm.domainListOptions
    },
    domProps: {
      "value": (_vm.domainId)
    },
    on: {
      "input": function($event) {
        _vm.domainId = $event
      }
    }
  }, [_c('div', {
    staticClass: "select-wrapper"
  }, [_vm._l((_vm.domainListOptions), function(option, key) {
    return [_c('v-option', {
      key: option.label,
      attrs: {
        "disabled": option.disabled,
        "label": option.label,
        "value": option.value
      }
    }, [_c('div', {
      staticClass: "option-wrapper"
    }, [_c('span', {
      attrs: {
        "title": option.label
      }
    }, [_vm._v(_vm._s(option.label))])])])]
  })], 2)]), (_vm.tip) ? _c('span', {
    staticStyle: {
      "color": "#d2b025"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "margin-right": "5px"
    }
  }), _vm._v(_vm._s(_vm.tip))]) : _vm._e(), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showExtraHTML),
      expression: "showExtraHTML"
    }],
    staticStyle: {
      "color": "#999"
    },
    domProps: {
      "innerHTML": _vm._s('（' + _vm.extraHTML + '）')
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e044da5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e044da5!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/component/domain-select.vue
// module id = 768
// module chunks = 0